module.exports = __webpack_public_path__ + "img/no-whatsnew-available.da5aeb96.svg";